export default __webpack_public_path__ + "static/media/PHP.43af2530.svg";